<template>
    <div style="height:100%;background:#A8A8A8;position:relative;">
        <div class="left-ball"></div>
        <div class="right-ball-top"></div>
        <div id="china_map_north" ref="ChinaEchart" style="width: 100%; "></div>
        <div class="main-area">
            <div class="left-ball"></div>
            <div class="right-ball"></div>
            <div class="title">
                <div class="num-box" id="company1">1</div><span class="company-name">{{$t('globalNet.function[1].componey[0].conpanyName')}}</span>
                <div style="height:18px;"></div>
                <div class="bottom-box">
                    <div class="item">
                        <div class="content">{{$t('globalNet.function[1].componey[0].address1')}}</div>
                        <div class="content">{{$t('globalNet.function[1].componey[0].address2')}}</div>
                    </div>
                    <div class="item">
                        <div class="content"><img src="../../assets/images/phone.svg">{{$t('globalNet.function[1].componey[0].phone')}}</div>
                        <!-- <div class="content"><img src="../../assets/images/mail.svg">{{$t('globalNet.function[1].componey[0].mail')}}</div> -->
                    </div>
                </div>
                <div style="height:55px;"></div>
                <div class="num-box" id="company2">2</div><span class="company-name">{{$t('globalNet.function[1].componey[1].conpanyName')}}</span>
                <div style="height:18px;"></div>
                <div class="bottom-box">
                    <div class="item">
                        <div class="content">{{$t('globalNet.function[1].componey[1].address1')}}</div>
                        <div class="content">{{$t('globalNet.function[1].componey[1].address2')}}</div>
                    </div>
                    <div class="item">
                        <div class="content"><img src="../../assets/images/phone.svg">{{$t('globalNet.function[1].componey[1].phone')}}</div>
                        <!-- <div class="content"><img src="../../assets/images/mail.svg">{{$t('globalNet.function[1].componey[1].mail')}}</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from "echarts"
import '../../../node_modules/echarts/map/js/china.js' //引入中国地图
export default ({
    watch:{
        '$i18n.locale':function(newLang,oldLang){
            if(newLang == 'en') {
                this.pointData = [{
                    name: "South West",
                    value: [104.104733,30.652319]
                },{
                    name: "North China",
                    value: [116.33943,39.125274]
                },{
                    name: "East China",
                    value: [121.504642,31.24186]
                },{
                    name: "South China",
                    value: [113.745411,23.019925]
                }]
            }else{
                this.pointData = [{
                    name: "西南",
                    value: [104.104733,30.652319]
                },{
                    name: "华北",
                    value: [116.33943,39.125274]
                },{
                    name: "华东",
                    value: [121.504642,31.24186]
                },{
                    name: "华南",
                    value: [113.745411,23.019925]
                }]
            }
            this.setEchartOption()
        }
    },
    data() {
        return {
            pointData: [],
            companyData:[
                [{
                    name: "1",
                    value: [117.259271,39.243253]
                }],
                [{
                    name: "2",
                    value: [117.507389,38.352885]
                }]
            ],
            options:{},
            dataList: [
            {
                name: "上海",
                value: 101
            },
            {
                name: "天津",
                value: 201
            },
            {
                name: "江苏",
                value: 101
            },
            {
                name: "江西",
                value: 101
            },
            {
                name: "广东",
                value: 101
            },
            {
                name: "四川",
                value: 101
            },
            {
                name: "河北",
                value: 201
            },
            ]
        }
    },
    created() {
        var lang = this.$i18n.locale
        if(lang == 'en') {
        this.pointData = [{
            name: "South West",
            value: [104.104733,30.652319]
        },{
            name: "North China",
            value: [116.33943,39.125274]
        },{
            name: "East China",
            value: [121.504642,31.24186]
        },{
            name: "South China",
            value: [113.745411,23.019925]
        }]
        }else{
        this.pointData = [{
            name: "西南",
            value: [104.104733,30.652319]
        },{
            name: "华北",
            value: [116.33943,39.125274]
        },{
            name: "华东",
            value: [121.504642,31.24186]
        },{
            name: "华南",
            value: [113.745411,23.019925]
        }]
        }
        this.setEchartOption();
    },
    methods: {
        initMap(){
            var _this = this
            let mapDiv = document.getElementById('china_map_north')
            let myChart = echarts.init(mapDiv)
            myChart.setOption(this.options)
            myChart.on('click', function (params) {
                if(params.seriesIndex == 1 || params.seriesIndex == 2){
                    var pageId = document.querySelector('#company' + params.seriesIndex)
                    window.scrollTo({
                        'top': pageId.offsetTop + 150,
                        'behavior': 'smooth'
                    })
                }
                if(params.name == '上海' || params.name == '江苏' || params.name == '江西'){
                    _this.$router.push('/globalNet/eastChina')
                } else if(params.name == '天津' || params.name == '河北'){
                    _this.$router.push('/globalNet/northChina')
                } else if(params.name == '四川') {
                    _this.$router.push('/globalNet/southwest')
                }
            })
        },
        //修改echart配制
        setEchartOption(){
            this.options = {
                visualMap: {
                    min: 0,
                    max: 1000,
                    left: 26,
                    bottom: 40,
                    seriesIndex: [0],
                    pieces: [{
                        gte: 0,
                        lte: 102,
                        color: "#cdcdcd"
                    },{
                        gt: 200,
                        color: "#ED6D00",
                    }],
                    show: false
                },
                geo: {
                    map: "china",
                    zoom: 2,
                    top: 50,
                    roam: true, //是否开启平游或缩放
                    scaleLimit: { //滚轮缩放的极限控制
                        min: 1,
                        max: 5
                    },
                    label: {
                        normal: {
                            show:false,
                        },
                        emphasis: {
                            show:false
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: "#d9d9d9",
                            borderColor: "#ffffff"
                        },
                        emphasis: {
                            areaColor: "#d9d9d9",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    },
                    regions: [{
                        name: '上海',
                        itemStyle: {
                        emphasis: {
                            areaColor: '#ED6D00'
                            }
                        }
                    },{
                        name: '天津',
                        itemStyle: {
                        emphasis: {
                            areaColor: '#ED6D00'
                            }
                        }
                    },{
                        name: '江苏',
                        itemStyle: {
                        emphasis: {
                            areaColor: '#ED6D00'
                            }
                        }
                    },{
                        name: '江西',
                        itemStyle: {
                        emphasis: {
                            areaColor: '#ED6D00'
                            }
                        }
                    },{
                        name: '广东',
                        itemStyle: {
                        emphasis: {
                            areaColor: '#ED6D00'
                            }
                        }
                    },{
                        name: '四川',
                        itemStyle: {
                        emphasis: {
                            areaColor: '#ED6D00'
                            }
                        }
                    },{
                        name: '河北',
                        itemStyle: {
                            emphasis: {
                                areaColor: '#ED6D00'
                            }
                        }
                    }]
                },
                series: [
                    {
                        name: "",
                        type: "map",
                        geoIndex: 0,
                        data:[],
                        itemStyle: {
                            normal: {
                                color: '#717171' //标志颜色
                            },
                            emphasis: {
                                show: false,
                                // color: '#717171'
                            }
                        }
                    },
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.companyData[0],
                        symbol: "image://" + require('@/assets/images/point1.svg'),
                        symbolSize: [20,25],
                        label: {
                            show: false
                        },
                        itemStyle: {
                            color: 'red'
                        },
                        zlevel: 1,
                    },
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.companyData[1],
                        symbol: "image://" + require('@/assets/images/point2.svg'),
                        symbolSize: [20,25],
                        label: {
                            show: false
                        },
                        itemStyle: {
                            color: 'red'
                        },
                        zlevel: 1,
                    },
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.pointData,
                        symbol: "image://" + require('@/assets/images/location1.svg'),
                        symbolSize: [15,20],
                        // symbol:'circle',
                        // symbolSize: [8, 8],
                        label: {
                            normal: {
                                show: true,
                                formatter: function (params) {
                                    if(params.name == '华北' || params.name == 'North China') {
                                        return '{a|' + params.name +'}'
                                    }else {
                                        return '{b|' + params.name +'}'
                                    }
                                },
                                position: 'top',
                                fontSize: '18',
                                rich: {
                                    a: {
                                        color: '#ffffff',
                                        fontSize: 18
                                    },
                                    b: {
                                        color: '#ED6D00',
                                        fontSize: 18
                                    }
                                }
                            }
                        },
                        itemStyle: {
                            color: '#ED6D00'
                        }
                    }
                ]
            }
            this.options.series[0]['data'] = this.dataList;
            this.$nextTick(()=>{
                this.initMap()
            })   
        },
        convertData(data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                var geoCoord = this.geoCoordMap[data[i].name];
                if (geoCoord) {
                    res.push({
                        name: data[i].name,
                        value: geoCoord.concat(data[i].value)
                    });
                }
            }
            return res
        }
    }
})
</script>
<style scoped>
    #china_map_north{
        height: 320px
    }
    @media screen and (max-width: 1399px) {
        #china_map_north {
            height: 320px;
        }
    }
    .main-area{
        position: relative;
        background: #ffffff;
        padding: 55px 50px;
        border-top: 1px solid #ED6D00;
        color: #4C4948;
        height: 100%;
    }
    .left-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        left: -15px;
        border-radius: 50%;
    }
    .right-ball-top{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        right: 0;
        border-radius: 50%;
    }
    .right-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        right: -15px;
        border-radius: 50%;
    }
    .title{
        margin-bottom: 18px;
    }
    .num-box{
        display: inline-block;
        margin-right: 10px;
        width: 30px;
        height: 30px;
        background: #ED6D00;
        border-radius: 50%;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
    }
    .bottom-box{
        display: flex;
        flex-wrap: wrap;
    }
    .bottom-box .item{
        width: 50%;
    }
    .content{
        font-size: 18px;
        margin-left: 40px;
        font-weight: 500;
        font-family: 'Lato','Microsoft JhengHei';
    }
    .content img{
        vertical-align: middle;
        position: relative;
        bottom: 2px;
        margin-right: 10px;
        width: 18px;
    }
    .company-name{
        /* font-family: 'Lato-Bold'; */
        font-family: 'Lato','Microsoft JhengHei';
    }
    @media screen and (max-width:768px) {
        #china_map_north{
            height: 380px
        }
        .main-area{
            padding: 50px 20px;
        }
        .bottom-box .item{
            width: 100%;
        }
    }
</style>       



// WEBPACK FOOTER //
// src/components/northChina/northChina.vue